<!-- components/TaxDetailsPopup.vue BR#98 - mbeng-->
<template>
    <div
      v-if="visible && shouldShow"
      class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-30"
    >
    <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center">
        <button
            @click="$emit('close')"
            class="absolute top-3 right-3 text-gray-400 hover:text-black"
            >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
            </button>
                
          <div class="text-center mb-4">
            <img src="@/assets/icm-logo.svg" alt="ICM.com" class="mx-auto h-8" />
        </div>
        <div class="flex items-center justify-center mb-3">
          <svg
            class="h-6 w-6 text-yellow-400 mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            />
          </svg>
          <h3 class="text-lg font-semibold text-yellow-700">
             {{ $t("important-information") }}
          </h3>
        </div>
        <p class="text-sm text-gray-700 mb-4">
            {{ $t("to-comply-with-regulatory-requirements-you-are-required-to-provide") }} <strong>30-04-2026.</strong>
        </p>
        <!-- <p class="text-sm text-gray-700 mt-2 mb-4">
            {{ $t("failure-to-complete-this-step-by-the-deadline-will-result-in-limited-access") }}
        </p> -->
        <p>
          {{$t("time-left")}}: <strong>{{ timeLeft }}</strong>
        </p>
        <br>
        <router-link
          to="/tax-details"
          class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {{ $t('complete-now') }} →
        </router-link>

        <button
          class="block text-sm text-gray-500 mt-3 mx-auto hover:underline"
          @click="$emit('close')"
        >
          {{ $t("remind-me-later") }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        countdown: {
            type: Number,
            default: 0,
        },
        deadline: {
            type: Date,
            required: true
        },
    },
    data() {
        return {
            timeLeft: '',   // Will hold countdown string like "2 days 5 hours 3 minutes"
            countdownTimer: null
        };
    },
    name: "TaxDetailsPopup",
    computed: {
      ...mapGetters(["get_profile"]),
      shouldShow() {
        // const fields = this.get_profile?.nic_fields || [];
        // const targetPriorities = [3, 4, 5, 6];
  
        // // Find any NIC field in the target priorities that has a value
        // const hasValid = fields.some(
        //   (f) =>
        //     targetPriorities.includes(f.priority) &&
        //     f.value &&
        //     f.value.trim() !== ""
        // );
  
        // // Show warning if none of them are filled
        // return !hasValid;
        const profileType = this.get_profile?.profile?.type;
        const nicFields = this.get_profile?.nic_fields || [];

        // Filter priority 3-6 fields with code 'TIN' and non-empty value
        const hasValidTIN = [3,4,5,6].some(priority => {
          const field = nicFields.find(n => n.priority === priority);
          return field && field.code === 'TIN' && field.value && field.value?.toString().trim() !== '';
        });

        return !hasValidTIN;
      },
      formattedCountdown() {
            const minutes = Math.floor(this.countdown / 60);
            const seconds = this.countdown % 60;
            return `${minutes}:${String(seconds).padStart(2, '0')}`;
        },
    },
    mounted() {
     this.startCountdown();
    },
    beforeDestroy() {
      clearInterval(this.countdownTimer);
    },
    methods: {
        startCountdown() {
            this.updateTimeLeft();
            this.countdownTimer = setInterval(this.updateTimeLeft, 1000);
        },
        updateTimeLeft() {
            const deadline = new Date("2026-04-30T00:00:00"); // 15th April 2026
            const now = new Date();
            const diff = deadline - now;

            if (diff <= 0) {
            this.timeLeft = '0 minutes';
            clearInterval(this.countdownTimer);
            //this.$emit('lockout'); // Optional: trigger lockout action
            this.$store.commit('SET_TAX_LOCKOUT', true)
            return;
            }

            const minutes = Math.floor(diff / 1000 / 60) % 60;
            const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
            const days = Math.floor(diff / 1000 / 60 / 60 / 24);

            this.timeLeft = `${days}d ${hours}h ${minutes}m`;
        }
    }
  };
  </script>
  